import { NewProductSpec } from "nvent-web/types/NewProductSpec";
import { Product } from "nvent-web/types/Product";
import { CategoryRecommendation } from "nvent-web/types/ProductRecommendation";

import Resource from "./Resource";

export default class ProductResource extends Resource {
  createSkus(projectId: number, roomId: number, specs: NewProductSpec[]) {
    return this.http.post<void>(`projects/${projectId}/rooms/${roomId}/product_skus`, { productSkus: specs });
  }

  createSku(projectId: number, roomId: number, spec: NewProductSpec) {
    return this.createSkus(projectId, roomId, [spec]);
  }

  getOne(projectId: number, roomId: number, productId: number) {
    return this.http.get<Product>(`projects/${projectId}/rooms/${roomId}/products/${productId}`);
  }

  getRecomendations(projectId: number, roomId: number) {
    return this.http.get<CategoryRecommendation[]>(`projects/${projectId}/rooms/${roomId}/product_sku_recommendations`);
  }

  test(
    projectId: number,
    roomId: number,
    productId: number,
    heatResistance: number,
    insulationResistance: number,
    testType: string
  ) {
    return this.http.post<Product>(`projects/${projectId}/rooms/${roomId}/products/${productId}/tests`, {
      heatResistance,
      insulationResistance,
      testType,
    });
  }

  removeProduct(projectId: number, roomId: number, productId: number) {
    return this.http.delete(`projects/${projectId}/rooms/${roomId}/products/${productId}`);
  }

  deleteAllProducts(projectId: number, roomId: number) {
    return this.http.delete(`projects/${projectId}/rooms/${roomId}/destroy_all`);
  }
}
